module.exports = __webpack_public_path__ + "static/media/2-1.a5db4f50.jpg";